var common = require("../utiles/common")

module.exports = {
    register: function () {
        document.createElement('tree')
        ko.components.register('tree', {
            viewModel: function (params) {
                layui.use('tree', function(){
                    var tree = layui.tree;
                    //渲染
                    var data = [{
                        title: '江西',
                        id:"1111"
                      }];
                    var inst1 = tree.render({
                        elem: '#tree-temp',
                        id:"tree-temp",
                        showLine:false,
                        data: data,
                        edit:true,
                        click: function(obj){
                            console.log(obj)
                        },
                        oncheck:function(obj){
                            console.log(obj)
                            if(!obj.data.children){
                                obj.data.children = [
                                    {title:"新增",id:Math.floor(Math.random())}
                                ]
                            }
                            tree.reload("tree-temp")
                        }
                    });
                  });
            },
            template: require("./Tree.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/template/Tree.js
// module id = 81
// module chunks = 0